import React from 'react';
import { ChevronRight, Lock } from 'lucide-react';
interface RecommendationsPanelProps {
  recommendations: string[];
  isUnlocked: boolean;
  onUnlock: () => void;
}
export function RecommendationsPanel({
  recommendations,
  isUnlocked,
  onUnlock
}: RecommendationsPanelProps) {
  if (recommendations.length === 0) return null;
  const [preview, ...rest] = recommendations;
  return <section aria-labelledby="recs-heading" className="rounded-2xl border border-forensic-line bg-forensic-surface p-6 sm:p-8" data-id="element-295" data-mp="o008rr2karj7">
      <h2 id="recs-heading" className="text-lg font-semibold text-white sm:text-xl" data-id="element-296" data-mp="jz6mt38ojmsy">
        Personalized recommendations
      </h2>
      <p className="mt-1 text-sm text-forensic-muted" data-id="element-297" data-mp="f1ew2cjru6qc">
        Basic communication guidance based on what was detected.
      </p>

      <ol className="mt-6 space-y-4" data-id="element-298" data-mp="2zqcfbeqvnusr">
        <RecItem index={1} text={preview} data-id="element-299" data-mp="2zrdxe36b9hjz" />
        {isUnlocked && rest.map((rec, i) => <RecItem key={rec} index={i + 2} text={rec} data-id="element-300" data-mp="2upyb67sed500" data-mpi={i} />)}
      </ol>

      {!isUnlocked && rest.length > 0 && <div className="mt-4" data-id="element-301" data-mp="11lxjiuqnj50v">
          {/* Placeholder lines only — locked recommendations are never rendered. */}
          <div className="space-y-4 blur-[1.5px]" aria-hidden="true" data-id="element-302" data-mp="15ketdm1gitlz">
            {[88, 72, 80].slice(0, Math.min(3, rest.length)).map(w => <div key={w} className="flex items-center gap-3" data-id="element-303" data-mp="wl9si92fao6n">
                <span className="h-6 w-6 shrink-0 rounded-full bg-white/[0.05]" data-id="element-304" data-mp="hx6q19nl9uml" />
                <span className="h-2 rounded-full bg-white/[0.07]" style={{
            width: `${w}%`
          }} data-id="element-305" data-mp="hv2d627ppla6" />
              </div>)}
          </div>
          <div className="mt-6 flex flex-col gap-3 border-t border-forensic-line pt-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-306" data-mp="8x9tymyvdthi">
            <p className="flex items-center gap-2 text-sm text-forensic-muted" data-id="element-307" data-mp="dvth2qp79bbg">
              <Lock size={13} className="text-forensic-crimson-soft" aria-hidden="true" data-id="element-308" data-mp="3v4zzuy3hj0r9" />
              Unlock the complete recommendation set
            </p>
            <button type="button" onClick={onUnlock} className="inline-flex min-h-[44px] items-center gap-1 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:text-forensic-crimson-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-forensic-crimson-soft" data-id="element-309" data-mp="3gxwo9sq7rekz">
              View full recommendations
              <ChevronRight size={16} aria-hidden="true" data-id="element-310" data-mp="3rmrzn4la5ee" />
            </button>
          </div>
        </div>}
    </section>;
}
function RecItem({
  index,
  text
}: {
  index: number;
  text: string;
}) {
  return <li className="flex items-start gap-3 text-sm leading-relaxed text-gray-200" data-id="element-311" data-mp="3pybnlw00iu7h">
      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/[0.06] text-xs font-medium text-forensic-muted tabular-nums" data-id="element-312" data-mp="3kzryjmq4h2aw">
        {index}
      </span>
      <span className="pt-0.5" data-id="element-313" data-mp="2ehbks6g1gwz7">{text}</span>
    </li>;
}